module.exports = __webpack_public_path__ + "assets/img/rule-2.0ec82c5d.png";